import { GlButtonGroup, GlButton, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
export default {
    name: 'ForksButton',
    components: {
        GlButtonGroup,
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        forksCount: {
            default: 0
        },
        projectForksUrl: {
            default: ''
        },
        userForkUrl: {
            default: ''
        },
        newForkUrl: {
            default: ''
        },
        canReadCode: {
            default: false
        },
        canForkProject: {
            default: false
        }
    },
    computed: {
        forkButtonUrl () {
            return this.userForkUrl || this.newForkUrl;
        },
        userHasForkAccess () {
            return Boolean(this.userForkUrl) && this.canReadCode;
        },
        userCanFork () {
            return this.canReadCode && this.canForkProject;
        },
        forkButtonEnabled () {
            return this.userHasForkAccess || this.userCanFork;
        },
        forkButtonTooltip () {
            if (!this.canForkProject) {
                return s__("ProjectOverview|You don't have permission to fork this project");
            }
            if (this.userHasForkAccess) {
                return s__('ProjectOverview|Go to your fork');
            }
            return s__('ProjectOverview|Create new fork');
        }
    }
};
